export default "__VITE_ASSET__clOri9u4__"